import type { SurveyQuestionForType, TypedSurveyQuestion } from "../../../types/survey.types";
import type { SurveyQuestionType } from "../../../data";

export interface ChoiceOptionErrorMessage {
  text?: string;
  value?: string;
}

export interface ScaleLabelErrorMessage {
  minLabel?: string;
  maxLabel?: string;
}

export interface DateRangeErrorMessage {
  minDate?: string;
  maxDate?: string;
  minDateTime?: string;
  maxDateTime?: string;
}

export interface YesNoLabelErrorMessage {
  yesLabel?: string;
  noLabel?: string;
}

export interface QuestionTypeRendererProps<TType extends SurveyQuestionType = SurveyQuestionType> {
  question: SurveyQuestionForType<TType>;
  index: number;
  isPreview: boolean;
  optionErrorMessages?: readonly ChoiceOptionErrorMessage[];
  scaleLabelErrorMessage?: ScaleLabelErrorMessage;
  dateRangeErrorMessage?: DateRangeErrorMessage;
  yesNoLabelErrorMessage?: YesNoLabelErrorMessage;
  onUpdateQuestion: (question: SurveyQuestionForType<TType>) => void;
}

export const noopRendererProps = {
  onUpdateQuestion: () => {},
} satisfies Pick<QuestionTypeRendererProps<TypedSurveyQuestion["type"]>, "onUpdateQuestion">;
